(function() {
  'use strict';

  const TERMS_URL_PATTERN = /\/pages\/non-exclusive-royalty-fair-license/;
  const HEADER_FOOTER_SELECTORS = 'header, footer, .site-header, .site-footer, .header, .footer';

  const styles = `
    .terms-modal-overlay {
      position: fixed !important;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.95);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
      overflow-y: auto;
      padding: 2rem 1rem;
    }

    .terms-modal-overlay.is-active {
      opacity: 1;
      visibility: visible;
    }

    .terms-modal {
      background: #000;
      border: 2px solid #ff5900;
      border-radius: 12px;
      max-width: 800px;
      width: 100%;
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      box-shadow: 0 8px 32px rgba(255, 89, 0, 0.4);
      position: relative !important;
      transform: translateY(20px);
      transition: transform 0.3s ease;
    }

    .terms-modal-overlay.is-active .terms-modal {
      transform: translateY(0);
    }

    .terms-modal__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.5rem 2rem;
      border-bottom: 1px solid rgba(255, 89, 0, 0.3);
      flex-shrink: 0;
    }

    .terms-modal__title {
      color: #ff5900;
      font-size: 1.5rem;
      font-weight: 700;
      margin: 0;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    .terms-modal__close {
      background: transparent;
      border: none;
      color: #ff5900;
      cursor: pointer;
      padding: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s ease, transform 0.2s ease;
    }

    .terms-modal__close:hover {
      color: #ff7a33;
      transform: rotate(90deg);
    }

    .terms-modal__close svg {
      width: 24px;
      height: 24px;
      stroke: currentColor;
      stroke-width: 2;
      fill: none;
    }

    .terms-modal__content {
      padding: 2rem;
      overflow-y: auto;
      flex: 1;
      color: #fff;
      line-height: 1.8;
      scrollbar-width: thin;
      scrollbar-color: #ff5900 #000;
    }

    .terms-modal__content::-webkit-scrollbar {
      width: 8px;
    }

    .terms-modal__content::-webkit-scrollbar-track {
      background: #000;
      border-radius: 4px;
    }

    .terms-modal__content::-webkit-scrollbar-thumb {
      background: #ff5900;
      border-radius: 4px;
    }

    .terms-modal__content::-webkit-scrollbar-thumb:hover {
      background: #ff7a33;
    }

    .terms-modal__content h1,
    .terms-modal__content h2,
    .terms-modal__content h3 {
      color: #ff5900;
      margin-top: 1.5rem;
      margin-bottom: 0.75rem;
      font-weight: 600;
    }

    .terms-modal__content h1 {
      font-size: 1.75rem;
    }

    .terms-modal__content h2 {
      font-size: 1.5rem;
    }

    .terms-modal__content h3 {
      font-size: 1.25rem;
    }

    .terms-modal__content p {
      margin-bottom: 1rem;
    }

    .terms-modal__content a {
      color: #ff5900;
      text-decoration: underline;
      transition: color 0.2s ease;
    }

    .terms-modal__content a:hover {
      color: #ff7a33;
    }

    .terms-modal__content ul,
    .terms-modal__content ol {
      margin-bottom: 1rem;
      padding-left: 1.5rem;
    }

    .terms-modal__content li {
      margin-bottom: 0.5rem;
    }

    .terms-modal__loading {
      text-align: center;
      padding: 3rem 2rem;
      color: #fff;
      font-size: 1rem;
    }

    .terms-modal__loading::after {
      content: '...';
      animation: dots 1.5s steps(4, end) infinite;
    }

    @keyframes dots {
      0%, 20% { content: '.'; }
      40% { content: '..'; }
      60%, 100% { content: '...'; }
    }

    .terms-modal__error {
      text-align: center;
      padding: 3rem 2rem;
      color: #ff5900;
      font-size: 1rem;
    }

    @media (max-width: 768px) {
      .terms-modal {
        max-height: 95vh;
        border-radius: 8px;
      }

      .terms-modal__header {
        padding: 1rem 1.5rem;
      }

      .terms-modal__title {
        font-size: 1.25rem;
      }

      .terms-modal__content {
        padding: 1.5rem;
      }

      .terms-modal-overlay {
        padding: 1rem;
      }
    }

    body.terms-modal-open {
      overflow: hidden;
    }
  `;

  function injectStyles() {
    if (document.getElementById('terms-modal-styles')) return;
    const styleEl = document.createElement('style');
    styleEl.id = 'terms-modal-styles';
    styleEl.textContent = styles;
    document.head.appendChild(styleEl);
  }

  function createModal() {
    const overlay = document.createElement('div');
    overlay.className = 'terms-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'terms-modal-title');

    overlay.innerHTML = `
      <div class="terms-modal">
        <div class="terms-modal__header">
          <h2 id="terms-modal-title" class="terms-modal__title">Terms of Service</h2>
          <button type="button" class="terms-modal__close" aria-label="Close modal">
            <svg viewBox="0 0 24 24">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="terms-modal__content">
          <div class="terms-modal__loading">Loading</div>
        </div>
      </div>
    `;

    return overlay;
  }

  function extractMainContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const selectors = [
      'main',
      '[role="main"]',
      '.main-content',
      '.page-content',
      '.rte',
      '.shopify-policy__container',
      '.policy-content',
      'article',
      '.content'
    ];

    for (const selector of selectors) {
      const element = doc.querySelector(selector);
      if (element && element.textContent.trim().length > 100) {
        return element.innerHTML;
      }
    }

    const body = doc.querySelector('body');
    if (body) {
      const clone = body.cloneNode(true);
      const toRemove = clone.querySelectorAll('header, footer, nav, script, style, .site-header, .site-footer, .header, .footer');
      toRemove.forEach(el => el.remove());
      return clone.innerHTML;
    }

    return '<p class="terms-modal__error">Unable to load content.</p>';
  }

  function openModal(url) {
    const modal = createModal();
    document.body.appendChild(modal);
    document.body.classList.add('terms-modal-open');

    const contentEl = modal.querySelector('.terms-modal__content');
    const closeBtn = modal.querySelector('.terms-modal__close');
    const modalBox = modal.querySelector('.terms-modal');

    setTimeout(() => modal.classList.add('is-active'), 10);

    function closeModal() {
      modal.classList.remove('is-active');
      document.body.classList.remove('terms-modal-open');
      setTimeout(() => {
        if (modal.parentNode) {
          modal.parentNode.removeChild(modal);
        }
      }, 300);
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escHandler);
      }
    });

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        const content = extractMainContent(html);
        contentEl.innerHTML = content;
      })
      .catch(error => {
        console.error('Error loading terms:', error);
        contentEl.innerHTML = '<p class="terms-modal__error">Failed to load Terms of Service. Please try again.</p>';
      });
  }

  function isInHeaderOrFooter(element) {
    return element.closest(HEADER_FOOTER_SELECTORS) !== null;
  }

  function interceptTermsLinks() {
    const links = document.querySelectorAll('a[href]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      
      if (href && TERMS_URL_PATTERN.test(href)) {
        if (!isInHeaderOrFooter(link)) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            const url = this.href;
            openModal(url);
          });
        }
      }
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        injectStyles();
        interceptTermsLinks();
      });
    } else {
      injectStyles();
      interceptTermsLinks();
    }
  }

  init();
})();

